<template>
  <div v-if="subCompanies && subCompanies.length > 0" class="sub-company-dropdown-wrapper">
    <a :uk-tooltip="`title: ${$t('general.sub_companies') || 'Alt Kurumlar'} ; pos: bottom ;offset:0`"
       class="header-widget-icon" href="javascript:void(0)" style="color:#ffffff !important">
      <i class="uil uil-building" style="color:#ffffff !important"></i>
    </a>

    <div ref="dropdownRef" class="dropdown-notifications dropdown-languages"
         uk-dropdown="pos: top-right;mode:click">
      <div class="dropdown-notifications-headline">
        <div class="uk-search uk-search-default uk-width-1-1">
          <span class="uk-search-icon-flip" uk-search-icon></span>
          <input v-model="searchTerm"
                 :placeholder="$t('general.search')"
                 class="uk-search-input uk-form-small"
                 type="search"
                 @input="onSearch"
          >
        </div>
      </div>

      <div class="dropdown-notifications-content" data-simplebar>
        <ul style="background-color:white">
          <!-- Ana Kurum Section -->
          <template v-for="(company, i) in filteredList">
            <li v-if="choosedCompany?.id !== company.id && company.id === parentCompany?.company_id"
                :key="'parent-' + i"
                class="parent-company-item"
                @click="onCompanySelect(company)">
              <a :title="company.name" class="navi-link parent-company-link" href="#">
                <i class="uil-building"></i>
                <div class="parent-company-content">
                  <span class="navi-text company-name">
                    {{ company.name }}
                    <span v-if="isPassiveCompany(company)" class="company-status-badge">
                      {{ $t('general.passive')}}
                    </span>
                  </span>
                  <span class="parent-company-badge">({{ $t('general.main_company') }})</span>
                </div>
              </a>
            </li>
          </template>

          <!-- Alt Kurumlar Section -->
          <template v-for="(company, i) in filteredList">
            <li v-if="choosedCompany?.id !== company.id && company.id !== parentCompany?.company_id"
                :key="'sub-' + i"
                class="sub-company-item"
                @click="onCompanySelect(company)">
              <a :title="company.name" class="navi-link sub-company-link" href="#">
                <i class="uil-arrow-right"></i>
                <span class="navi-text company-name">
                  {{ company.name }}
                  <span v-if="isPassiveCompany(company)" class="company-status-badge">
                    {{ $t('general.passive') }}
                  </span>
                </span>
              </a>
            </li>
          </template>

          <li v-if="filteredList.length === 0 && searchTerm"
              class="uk-text-center uk-padding-small no-results-message">
            {{ $t('general.notFoundCompany') }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubCompanyDropdown",
  props: {
    subCompanies: {
      type: Array,
      default: () => [],
    },
    choosedCompany: {
      type: Object,
      default: null,
    },
    parentCompany: {
      type: [Object, Number],
      default: null,
    },
  },
  data() {
    return {
      searchTerm: "",
      filteredList: [],
    };
  },
  watch: {
    subCompanies: {
      handler(newVal) {
        this.filteredList = this.getUniqueCompanies(newVal || []);
        this.searchTerm = "";
      },
      immediate: true,
    },
  },
  methods: {
    hide() {
      if (this.$refs.dropdownRef) {
        UIkit.dropdown(this.$refs.dropdownRef).hide(0);
      }
    },
    getUniqueCompanies(companies) {
      const uniqueMap = new Map();
      companies.forEach(company => {
        if (!uniqueMap.has(company.id)) {
          uniqueMap.set(company.id, company);
        }
      });
      return Array.from(uniqueMap.values());
    },
    onSearch() {
      if (!this.searchTerm) {
        this.filteredList = this.getUniqueCompanies(this.subCompanies || []);
      } else {
        const term = this.searchTerm.toLowerCase();
        const unique = this.getUniqueCompanies(this.subCompanies || []);
        this.filteredList = unique.filter(c => c.name.toLowerCase().includes(term));
      }
    },
    onCompanySelect(company) {
      this.$emit("select", company);
    },
    isPassiveCompany(company) {
      return Number(company?.status_id) === 0;
    },
  },
};
</script>

<style>
.no-results-message {
  color: #ef4444 !important;
  font-weight: 500 !important;
  font-style: italic !important;
  background-color: #fef2f2 !important;
  border: 1px solid #fecaca !important;
  border-radius: 4px !important;
  margin: 8px !important;
  padding: 12px !important;
}

/* Company hierarchy styling */
.parent-company-item {
  border-bottom: 1px solid #e5e7eb !important;
  margin-bottom: 8px !important;
  position: relative !important;
}

.parent-company-link {
  background: linear-gradient(135deg, #f8fafc 0%, #e0f2fe 100%) !important;
  font-weight: 600 !important;
  color: #1e40af !important;
  padding: 12px 15px !important;
  display: flex !important;
  align-items: flex-start !important;
  gap: 10px !important;
  border: 1px solid #e0f2fe !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.2s ease !important;
  min-height: 50px !important;
  position: relative !important;
}

.parent-company-link:hover {
  background: linear-gradient(135deg, #e0f2fe 0%, #bfdbfe 100%) !important;
  color: #1565c0 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15) !important;
}

.parent-company-link i {
  flex-shrink: 0 !important;
  font-size: 18px !important;
  color: #3b82f6 !important;
  margin-top: 2px !important;
}

.parent-company-content {
  display: flex !important;
  align-items: flex-start !important;
  flex: 1 !important;
  min-width: 0 !important;
  padding-right: 55px !important;
  flex-direction: column !important;
}

.parent-company-link .navi-text {
  flex: 1 !important;
  font-size: 14px !important;
  line-height: 1.4 !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  white-space: normal !important;
  max-width: none !important;
}

.parent-company-badge {
  position: absolute !important;
  top: 0px !important;
  right: 8px !important;
  color: #090909 !important;
  border-radius: 12px !important;
  font-size: 9px !important;
  font-weight: 700 !important;
  white-space: nowrap !important;
  text-transform: uppercase !important;
}

.sub-company-item {
  margin-left: 10px !important;
  margin-bottom: 2px !important;
}

.sub-company-link {
  padding: 8px 12px !important;
  color: #4b5563 !important;
  font-weight: 400 !important;
  border-left: 3px solid transparent !important;
  transition: all 0.2s ease !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  border-radius: 6px !important;
  min-height: 36px !important;
}

.sub-company-link:hover {
  background-color: #f8fafc !important;
  color: #1f2937 !important;
  border-left-color: #3b82f6 !important;
  padding-left: 15px !important;
  transform: translateX(2px) !important;
}

.sub-company-link i {
  color: #9ca3af !important;
  font-size: 12px !important;
  flex-shrink: 0 !important;
}

.sub-company-link .navi-text {
  flex: 1 !important;
  font-size: 13px !important;
  line-height: 1.3 !important;
  white-space: normal !important;
  overflow: hidden !important;
  max-width: 200px !important;
}

.company-name {
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  min-width: 0 !important;
}

.company-status-badge {
  flex-shrink: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  padding: 1px 6px !important;
  border-radius: 10px !important;
  background-color: #fee2e2 !important;
  color: #b91c1c !important;
  font-size: 10px !important;
  font-weight: 700 !important;
  line-height: 1.4 !important;
  text-transform: uppercase !important;
}

/* Mobil: Dropdown ekran dışına taşmasın */
@media (max-width: 640px) {
  .sub-company-dropdown-wrapper .dropdown-notifications.dropdown-languages {
    position: fixed !important;
    top: 56px !important;
    right: 8px !important;
    left: auto !important;
    width: calc(100vw - 16px) !important;
    max-width: 300px !important;
  }

  .sub-company-dropdown-wrapper .dropdown-notifications.dropdown-languages:before {
    display: none;
  }
}
</style>
